import React from 'react';

export function Footer() {
  return (
    <footer className="bg-gray-50 border-t border-gray-200 py-4 mt-auto">
      <div className="max-w-4xl mx-auto px-4 text-center text-sm text-gray-600">
        <p>© {new Date().getFullYear()} FT Viagens - Todos os direitos reservados</p>
      </div>
    </footer>
  );
}